import React from 'react';

const Contact = () => {
    return (
        <div>
            <h1>Contact is comming soon....</h1>
        </div>
    );
};

export default Contact;